import { useId } from "react";

const LEAVES = [
  { left: "4%", delay: "0s", dur: "14s", spin: "3s", size: 26, fill: "#4ADE80" },
  { left: "12%", delay: "3s", dur: "17s", spin: "4s", size: 18, fill: "#86EFAC" },
  { left: "22%", delay: "6s", dur: "13s", spin: "5s", size: 22, fill: "#FBBF24" },
  { left: "35%", delay: "1.5s", dur: "16s", spin: "6s", size: 16, fill: "#22C55E" },
  { left: "48%", delay: "8s", dur: "18s", spin: "3s", size: 28, fill: "#A3E635" },
  { left: "58%", delay: "4s", dur: "12s", spin: "4s", size: 20, fill: "#F59E0B" },
  { left: "68%", delay: "10s", dur: "15s", spin: "5s", size: 18, fill: "#4ADE80" },
  { left: "78%", delay: "2s", dur: "19s", spin: "6s", size: 24, fill: "#86EFAC" },
  { left: "88%", delay: "7s", dur: "14s", spin: "3s", size: 16, fill: "#FBBF24" },
  { left: "94%", delay: "5s", dur: "16s", spin: "4s", size: 22, fill: "#22C55E" },
  { left: "30%", delay: "11s", dur: "20s", spin: "5s", size: 14, fill: "#A3E635" },
  { left: "72%", delay: "13s", dur: "17s", spin: "6s", size: 20, fill: "#4ADE80" },
];

const LAND_A = "M18 72 C38 48 72 52 88 70 C104 88 92 112 68 118 C42 124 10 98 18 72 Z M96 40 C128 22 176 28 196 54 C214 78 198 104 164 108 C128 112 86 72 96 40 Z M54 128 C72 118 98 124 108 140 C116 156 96 168 76 164 C58 160 44 140 54 128 Z";
const LAND_B = "M210 86 C236 70 274 78 288 98 C300 116 284 138 254 140 C226 142 198 110 210 86 Z M150 148 C168 140 196 148 206 164 C214 180 196 192 174 188 C154 184 138 160 150 148 Z";

function Petal({ size, fill }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M3 21 C3 9, 12 3, 21 3 C21 15, 12 21, 3 21 Z" fill={fill} fillOpacity="0.85" />
      <path d="M4 20 L19 5" stroke="#06110A" strokeWidth="0.8" strokeOpacity="0.5" />
    </svg>
  );
}

export function EarthLeaves() {
  const raw = useId().replace(/:/g, "");
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden data-testid="hero-earth-leaves">
      <div className="earth-wrap hidden md:block absolute -right-24 top-[-20px] lg:right-[6%] lg:-top-10 w-[420px] h-[420px] lg:w-[540px] lg:h-[540px] opacity-45">
        <div className="absolute inset-8 rounded-full bg-emerald-500/25 blur-3xl earth-breathe" />
        <svg viewBox="0 0 240 240" className="absolute inset-0 w-full h-full earth-tilt">
          <defs>
            <clipPath id={`${raw}-clip`}><circle cx="120" cy="120" r="100" /></clipPath>
            <radialGradient id={`${raw}-shade`} cx="35%" cy="35%" r="75%">
              <stop offset="0%" stopColor="#0E3B2A" />
              <stop offset="70%" stopColor="#07140E" />
              <stop offset="100%" stopColor="#030806" />
            </radialGradient>
            <radialGradient id={`${raw}-rim`} cx="50%" cy="50%" r="50%">
              <stop offset="80%" stopColor="transparent" />
              <stop offset="100%" stopColor="#22C55E" stopOpacity="0.55" />
            </radialGradient>
          </defs>
          <circle cx="120" cy="120" r="100" fill={`url(#${raw}-shade)`} />
          <g clipPath={`url(#${raw}-clip)`}>
            <g className="earth-continents">
              <g fill="#22C55E" fillOpacity="0.58" stroke="#4ADE80" strokeOpacity="0.45" strokeWidth="0.7">
                <path d={LAND_A} />
                <path d={LAND_B} />
                <path d={LAND_A} transform="translate(240 8)" />
                <path d={LAND_B} transform="translate(240 -6)" />
              </g>
              <g stroke="#86EFAC" strokeOpacity="0.22" strokeWidth="0.6" fill="none">
                {[0, 48, 96, 144, 192, 240, 288, 336, 384, 432].map((x) => (
                  <path key={x} d={`M${x} 20 C${x + 24} 60, ${x + 24} 180, ${x} 220`} />
                ))}
              </g>
            </g>
            <g stroke="#86EFAC" strokeOpacity="0.2" strokeWidth="0.7" fill="none">
              <line x1="20" y1="120" x2="220" y2="120" />
              <ellipse cx="120" cy="120" rx="100" ry="34" />
              <ellipse cx="120" cy="120" rx="100" ry="68" />
              <line x1="20" y1="76" x2="220" y2="76" />
              <line x1="20" y1="164" x2="220" y2="164" />
            </g>
          </g>
          <circle cx="120" cy="120" r="100" fill={`url(#${raw}-rim)`} />
          <circle cx="120" cy="120" r="100" fill="none" stroke="#4ADE80" strokeOpacity="0.35" strokeWidth="0.8" />
          <g className="earth-sat-orbit">
            <circle cx="120" cy="14" r="3" fill="#FBBF24" />
            <circle cx="120" cy="14" r="7" fill="#FBBF24" fillOpacity="0.25" />
          </g>
          <ellipse cx="120" cy="120" rx="128" ry="26" fill="none" stroke="#F59E0B" strokeOpacity="0.25" strokeWidth="0.7" strokeDasharray="3 5" className="earth-gold-ring" />
        </svg>
      </div>
      {LEAVES.map((leaf, i) => (
        <div key={i} className="earth-leaf-fall absolute -top-10" style={{ left: leaf.left, animationDelay: leaf.delay, animationDuration: leaf.dur }}>
          <div className="earth-leaf-spin" style={{ animationDuration: leaf.spin }}>
            <Petal size={leaf.size} fill={leaf.fill} />
          </div>
        </div>
      ))}
    </div>
  );
}
